import React from "react";
import { Box, Button, FormControl, Grid, MenuItem, Select, Typography, Stack } from "@mui/material";
import { ReactComponent as ContactDetailsIcon } from "../../Icons/ContactDetails.svg";
import { useNavigate } from "react-router-dom";
import { SecondaryTypography } from "../../Theme";

const hours = Array.from({ length: 12 }, (_, i) => String(i + 1).padStart(2, "0"));
const minutes = Array.from({ length: 60 }, (_, i) => String(i).padStart(2, "0"));
const ampm = ["AM", "PM"];

const TimeRangePicker = ({ value, onChange, saveDevice }) => {
    const navigate = useNavigate()
  const handleChange = (field, newValue) => {
    onChange({
      ...value,
      [field]: newValue,
    });
  };

  return (
    <>
    


<Box
          mt={3}
          component="div"
        //   boxShadow="0 0 3px 0 rgba(0 ,0 ,0 ,0.1)"
          borderRadius="8px"
        >
          <Stack
            direction="row"
            alignItems="center"
            gap="10px"
            px="16px"
            sx={{
              height: "66px",
              backgroundColor: "#FCFCFD",
              border: "1px solid #E5E7EB",
              borderRadius: "8px 8px 0 0 ",
            }}
          >
            <ContactDetailsIcon />
            <SecondaryTypography>Operating Hours</SecondaryTypography>
          </Stack>
          <Grid
            container
            xs={12}
            gap="2.8%"
            sx={{
              backgroundColor: "white",
              padding: "30px 16px 30px 16px",
              border: "1px solid #E5E7EB",
              borderRadius: "0 0 8px 8px  ",
            }}
          >
            <Grid xs={12} sm={5.8}>
              <Box display="flex" flexDirection="column" gap={2}>
      {/* FROM TIME */}
      <Box display="flex" flexDirection="column">
        <Typography fontWeight={600}>From Time</Typography>
        <Box display="flex" gap={1}>
          <FormControl size="small" sx={{ minWidth: 70 }}>
            <Select
              value={value.fromHour}
              onChange={(e) => handleChange("fromHour", e.target.value)}
            >
              {hours.map((h) => (
                <MenuItem key={h} value={h}>{h}</MenuItem>
              ))}
            </Select>
          </FormControl>

          <FormControl size="small" sx={{ minWidth: 70 }}>
            <Select
              value={value.fromMinute}
              onChange={(e) => handleChange("fromMinute", e.target.value)}
            >
              {minutes.map((m) => (
                <MenuItem key={m} value={m}>{m}</MenuItem>
              ))}
            </Select>
          </FormControl>

          <FormControl size="small" sx={{ minWidth: 70 }}>
            <Select
              value={value.fromAMPM}
              onChange={(e) => handleChange("fromAMPM", e.target.value)}
            >
              {ampm.map((a) => (
                <MenuItem key={a} value={a}>{a}</MenuItem>
              ))}
            </Select>
          </FormControl>
        </Box>
      </Box>

      {/* TO TIME */}
      <Box display="flex" flexDirection="column">
        <Typography fontWeight={600}>To Time</Typography>
        <Box display="flex" gap={1}>
          <FormControl size="small" sx={{ minWidth: 70 }}>
            <Select
              value={value.toHour}
              onChange={(e) => handleChange("toHour", e.target.value)}
            >
              {hours.map((h) => (
                <MenuItem key={h} value={h}>{h}</MenuItem>
              ))}
            </Select>
          </FormControl>

          <FormControl size="small" sx={{ minWidth: 70 }}>
            <Select
              value={value.toMinute}
              onChange={(e) => handleChange("toMinute", e.target.value)}
            >
              {minutes.map((m) => (
                <MenuItem key={m} value={m}>{m}</MenuItem>
              ))}
            </Select>
          </FormControl>

          <FormControl size="small" sx={{ minWidth: 70 }}>
            <Select
              value={value.toAMPM}
              onChange={(e) => handleChange("toAMPM", e.target.value)}
            >
              {ampm.map((a) => (
                <MenuItem key={a} value={a}>{a}</MenuItem>
              ))}
            </Select>
          </FormControl>
        </Box>
      </Box>
    </Box>
            </Grid>
            <Grid xs={12} sm={5.8}>
              
            </Grid>

             
          
            
           
          </Grid>

            <Box bgcolor="#FFFFFF" sx={{ border: "1px solid #E5E7EB", borderRadius: '8px 8px 8px 8px', mt : 2 }}>
                <Stack direction="column" justifyContent='end' alignItems='end' sx={{ py : 2, px : 2, display: 'flex', gap : 2 , flexDirection : { xs : 'column', sm : 'row'} }}>
                    {/* <Button type='button' onClick={() => navigate(-1)} sx={{ fontWeight: '600', width: "100px", color: '#800000', backgroundColor: "#f3eae7ff" }}>Back</Button> */}
                    <Button type='button' onClick={() => saveDevice()} sx={{ fontWeight: '600', width: "100px", color: 'white', backgroundColor: "#800000" }}>{"Set Time"}</Button>
                </Stack>
            </Box>
        </Box>
        </>
  );
};

export default TimeRangePicker;